import { getAppNewVersion, getAuditList } from '@/http/home'

const homeStore = {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 查看是否是最新版本
    fetchAppNewVersion ({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAppNewVersion(params).then(res => {
          if (!res) return
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查看用户的审批信息
    fetchAuditList ({ commit }) {
      return new Promise((resolve, reject) => {
        getAuditList().then(res => {
          if (!res) return
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default homeStore



// WEBPACK FOOTER //
// ./src/views/home/homeStore.js